<template>
  <div class="scoreRule">
    <el-container>
      <el-aside
        width="240px"
        style="padding-right:10px;overflow: auto;background: #fff;border-radius: 4px;padding-top:10px;"
      >
        <span style="font-size: 16px;color: #455A64;margin-left:12px;">选择科目</span>

        <tree ref="mytree" v-on:setGuide="changeSubject" value="guide"></tree>
      </el-aside>
      <!-- <el-main style="margin-top:-20px;padding-bottom:0px;" v-if="subject!=null&&subject.id!=null&&subject.id!=''"> -->
      <el-main
        v-if="subject!=null&&subject.id!=null&&subject.id!=''"
        style="margin-top:-20px;padding-bottom:0px;"
      >
        <el-tabs v-model="activeName">
          <el-tab-pane label="报考指南" name="first">
            <div
              style="background-color:#fff;padding:10px;display:flex;justify-content: space-between;align-items:center;"
            >
              <div>{{subject.name}}--报考指南</div>
              <div>
                <el-switch
                  v-auth="'/applyGuide/changeState'"
                  v-model="applyGuidForm.state"
                  :active-value="1"
                  :inactive-value="-1"
                  @change="changeState"
                ></el-switch>
              </div>
            </div>
            <el-form
              ref="applyGuidForm"
              :model="applyGuidForm"
              :rules="applyGuidFormRules"
              style="background-color:#fff;padding:20px;margin-right: -20px;"
            >
              <el-row :gutter="20">
                <el-col :sm="12" :md="12" :lg="12">
                  <el-form-item label="报名时间" prop="applyTime">
                    <el-input
                      v-model="applyGuidForm.applyTime"
                      placeholder="报名时间"
                      auto-complete="off"
                      maxlength="255"
                    ></el-input>
                    <!-- <el-date-picker
                      v-model="applyGuidForm.applyTime"
                      type="date"
                      placeholder="报名时间"
                      :value-format="dateformat"
                    ></el-date-picker>-->
                  </el-form-item>
                </el-col>
                <el-col :sm="12" :md="12" :lg="12">
                  <el-form-item label="准考证打印时间" prop="ticketTime">
                    <el-input
                      v-model="applyGuidForm.ticketTime"
                      placeholder="准考证打印时间"
                      auto-complete="off"
                      maxlength="255"
                    ></el-input>
                    <!-- <el-date-picker
                      v-model="applyGuidForm.ticketTime"
                      type="date"
                      placeholder="准考证打印时间"
                      :value-format="dateformat"
                    ></el-date-picker>-->
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :sm="12" :md="12" :lg="12">
                  <el-form-item label="考试时间" prop="examTime">
                    <!-- <el-input
                      v-model="applyGuidForm.examTime"
                      placeholder="考试时间"
                      auto-complete="off"
                      maxlength="255"
                    ></el-input>-->
                    <el-date-picker
                      style="display: block;width: 100%;height: 32px;margin-top: 32px;"
                      v-model="applyGuidForm.examTime"
                      type="date"
                      placeholder="考试时间"
                      :value-format="dateformat"
                      :format="dateformat"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :sm="12" :md="12" :lg="12">
                  <el-form-item label="成绩查询时间" prop="queryScore">
                    <el-input
                      v-model="applyGuidForm.queryScore"
                      placeholder="成绩查询时间"
                      auto-complete="off"
                      maxlength="255"
                    ></el-input>
                    <!-- <el-date-picker
                      v-model="applyGuidForm.queryScore"
                      type="date"
                      placeholder="成绩查询时间"
                      :value-format="dateformat"
                    ></el-date-picker>-->
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :sm="24" :md="24" :lg="24">
                  <div class="tabs-list">
                    <div
                      :class="nowIndex==index?'list-item':'list-items'"
                      v-for="(item,index) in applyGuidForm.applyGuideItemList"
                      @click="changeIowIndex(index)"
                      :key="index"
                    >
                      <span style="font-size:16px">{{item.title}}</span>
                      <i v-auth="'/applyGuide/deleteTabs'" class="iconfont iconicon7" @click="deleteTabs(index)"></i>
                    </div>
                    <div v-auth="'/applyGuide/addTabs'" @click="addTabs" class="list-item">
                      <i class="iconfont iconicon-test"></i>
                      <span style="font-size:16px">添加</span>
                    </div>
                  </div>
                  <div v-for="(item,index) in applyGuidForm.applyGuideItemList" :key="index">
                    <div v-if="nowIndex==index" class="name-content">
                      <div class="spans">标题名称</div>
                      <el-input
                        style="width:200px;"
                        v-model="item.title"
                        placeholder="请输入标题名"
                        auto-complete="off"
                        maxlength="255"
                      ></el-input>
                    </div>
                    <div v-if="nowIndex==index" class="name-content">
                      <div class="spans">内容</div>
                      <UE
                        :id="`ue${index}`"
                        @setGuide="setGuideContent"
                        :value="item.content"
                        :ref="`myUe${index}`"
                      ></UE>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <el-form-item>
                <el-button v-auth="'/applyGuide/save'" type="primary" @click="save">保 存</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="新闻资讯" name="second">
            <div style="background-color:#fff;">
              <div
                style="background-color:#fff;padding:10px;display:flex;justify-content: space-between;align-items:center;"
              >
                <div>{{subject.name}}--新闻资讯</div>
              </div>
              <el-row :span="24" style="padding:10px;">
                <el-col :span="12">
                  <el-button v-auth="'/applyGuide/addFormSubmit'" type="primary" icon="el-icon-plus" @click="addFormVisible=true">新增</el-button>
                  <el-button v-auth="'/applyGuide/deleteNews'" type="danger" icon="el-icon-minus" @click="deleteNews()">删除</el-button>
                </el-col>
              </el-row>
              <div style="padding:10px;">
                <el-table
                  ref="multipleTable"
                  :data="tableList"
                  tooltip-effect="dark"
                  @selection-change="selectionChange"
                  border
                >
                  <el-table-column type="selection" width="55"></el-table-column>

                  <el-table-column prop="title" label="标题" width="160" show-overflow-tooltip></el-table-column>
                  <el-table-column
                    prop="viewNum"
                    align="center"
                    width="80"
                    label="查看量"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="likeNum"
                    align="center"
                    width="80"
                    label="点赞量"
                    show-overflow-tooltip
                  ></el-table-column>

                  <el-table-column prop="state" label="状态" width="80" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div class="message">
                        <div class="state">
                          <span v-if="scope.row.state==1" style="background:rgb(24,200,168)">上架</span>
                          <span v-else style="background:rgba(231, 76, 60, 1);">未上架</span>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="content" label="内容" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div class="message">
                        <div class="htmltittle" v-html="scope.row.content"></div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="createTime"
                    align="center"
                    width="100"
                    label="创建时间"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column prop label="操作" width="120" align="center">
                    <template slot-scope="scope">
                      <div class="operationGroup">
                        <i
                          v-auth="'/applyGuide/editNews'"
                          class="iconfont iconbianji mainColor"
                          @click="getNewsInfo(scope.row.id)"
                          title="编辑"
                        ></i>
                        <i
                          v-auth="'/applyGuide/deleteNews'"
                          class="iconfont iconshanchu mainColor"
                          @click="deleteItem(scope.row.id)"
                          title="删除"
                        ></i>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  background
                  :page-sizes="[10, 20, 50, 100]"
                  layout="total, sizes, prev, pager, next, jumper"
                  style="margin-top: 20px;text-align: right;"
                  :total="page.total"
                  :page-size="page.pageSize"
                  :current-page="page.pageNumber"
                  @size-change="sizeChange"
                  @current-change="currentChange"
                ></el-pagination>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-main>
      <el-main v-else style="margin-top:-20px;padding-bottom:0px;">
        <div class="none">请选择科目</div>
      </el-main>
    </el-container>

    <el-dialog title="新增" :visible.sync="addFormVisible" width="800px" left>
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="标题" prop="title">
              <el-input v-model="addForm.title" placeholder="请输入标题"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="文章来源" prop="source">
              <el-input v-model="addForm.source" placeholder="请输入文章来源"></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="排序" prop="sort">
              <el-input type="number" v-model="addForm.sort" placeholder="请输入排序"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="上架" prop="state">
              <el-switch
                v-model="addForm.state"
                class="switchStyle wz"
                :active-value="1"
                :inactive-value="-1"
                active-text="是"
                inactive-text="否"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="图片" prop="img">
              <div
                v-if="!addForm.img"
                style="
                display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;"
              >
                <el-upload
                  class="crm-upload"
                  :action="fileObj.url"
                  :on-remove="handleRemove"
                  :on-change="handleChange"
                  :before-upload="beforeUpload"
                  :on-success="UploadSuccess"
                  :headers="reqData"
                  :show-file-list="false"
                >
                  <div class="content-text">上传图片</div>
                </el-upload>
                <span style="margin-left:10px">建议正方形尺寸图片</span>
              </div>
              <el-row v-else :span="24">
                <el-col :sm="15" :md="15" :lg="15">
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="addForm.img"
                    :preview-src-list="[addForm.img]"
                  ></el-image>
                </el-col>
                <el-col :sm="9" :md="9" style="float:right" :lg="9">
                  <el-button
                    type="danger"
                    size="small"
                    icon="el-icon-minus"
                    @click="addForm.img=''"
                  >删除</el-button>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <!-- <el-form-item label="内容" prop="type">
              <UE id="addUE" ref="addUE"></UE>
            </el-form-item>-->
            <div class="row-line">
              <div class="line1">
                <span style="color: #F56C6C;margin-right: 4px;">*</span>
                <span>内容</span>
              </div>
              <div class="line2">
                <UE id="addUE" ref="addUE"></UE>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addFormSubmit">保 存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑" :visible.sync="editFormVisible" width="800px" left>
      <el-form ref="editForm" :model="editForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="标题" prop="title">
              <el-input v-model="editForm.title" placeholder="请输入标题"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="文章来源" prop="source">
              <el-input v-model="editForm.source" placeholder="请输入文章来源"></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="排序" prop="sort">
              <el-input type="number" v-model="editForm.sort" placeholder="请输入排序"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="12" :md="12" :lg="12">
            <el-form-item label="上架" prop="state">
              <el-switch
                v-model="editForm.state"
                class="switchStyle wz"
                :active-value="1"
                :inactive-value="-1"
                active-text="是"
                inactive-text="否"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="图片" prop="img">
              <div
                v-if="!editForm.img"
                style="
                display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;"
              >
                <el-upload
                  class="crm-upload"
                  :action="fileObj.url"
                  :on-remove="handleRemove"
                  :on-change="handleChange"
                  :before-upload="beforeUpload"
                  :on-success="UploadSuccess"
                  :headers="reqData"
                  :show-file-list="false"
                >
                  <div class="content-text">上传图片</div>
                </el-upload>
                <span style="margin-left:10px">建议正方形尺寸图片</span>
              </div>
              <el-row v-else :span="24">
                <el-col :sm="15" :md="15" :lg="15">
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="editForm.img"
                    :preview-src-list="[editForm.img]"
                  ></el-image>
                </el-col>
                <el-col :sm="9" :md="9" style="float:right" :lg="9">
                  <el-button
                    type="danger"
                    size="small"
                    icon="el-icon-minus"
                    @click="editForm.img=''"
                  >删除</el-button>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <!-- <el-form-item label="*内容" prop="type">
              <UE id="editUE" :value="editForm.content" ref="editUE"></UE>
            </el-form-item>-->
            <div class="row-line">
              <div class="line1">
                <span style="color: #F56C6C;margin-right: 4px;">*</span>
                <span>内容</span>
              </div>
              <div class="line2">
                <UE id="editUE" :value="editForm.content" ref="editUE"></UE>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="editFormSubmit">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import UE from "../question/UE.vue";

import tree from "../conmom/tree";

export default {
  components: { tree, UE },

  data() {
    return {
      dateformat: "yyyy/MM/dd",
      page: {
        total: 0,
        pageSize: 10,
        pageNumber: 1
      },
      fileObj: {
        url: process.env.BASE_URL + "/system/uploadFile"
      },
      formLabelWidth: "80px",
      addFormRules: {
        title: [
          {
            required: true,
            message: "请输入类型名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "长度在1到255个字"
          }
        ],
        sort: [
          {
            pattern: /^[1-9]\d*$/,
            message: "排序格式不正确"
          }
        ]
      },
      addFormVisible: false,
      editFormVisible: false,
      editForm: {},
      addForm: {
        state: 1,
        sort: null,
        title: "",
        source: "",
        content: "",
        img: ""
      },
      subject: {},
      tableList: [],
      idList: [],
      activeName: "first",
      nowIndex: 0,
      applyGuidForm: {
        id: "",
        subjectId: "",
        banner: "",
        applyTime: "",
        ticketTime: "",
        examTime: "",
        queryScore: "",
        state: "",
        applyGuideItemList: [{ title: "", content: "" }]
      },
      applyGuidFormRules: {
        applyTime: [
          {
            required: true,
            message: "请输入报名时间",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "报名时间长度在1到255个字"
          }
        ],
        ticketTime: [
          {
            required: true,
            message: "请输入准考证打印时间",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "准考证打印时间长度在1到255个字"
          }
        ],
        examTime: [
          {
            required: true,
            message: "请输入考试时间",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "考试时间长度在1到255个字"
          }
        ],
        queryScore: [
          {
            required: true,
            message: "请输入成绩查询时间",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "成绩查询时间长度在1到255个字"
          }
        ]
      }
    };
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    }
  },
  methods: {
    detachange(val) {
      console.log(val);
    },
    deleteItem(id) {
      this.idList = [id];
      this.deleteNews();
    },
    getNewsInfo(id) {
      this.api
        .getNewsInfo({
          id: id
        })
        .then(result => {
          if (result.success) {
            this.editForm = result.data;
            this.editFormVisible = true;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    formatDate(_, date) {
      date = new Date(date);
      let o = {
        "Y+": date.getFullYear(), //月份
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds() //毫秒
      };
      if (/(y+)/.test(_))
        _ = _.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      for (let k in o)
        if (new RegExp("(" + k + ")").test(_))
          _ = _.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
      return _;
    },
    editFormSubmit() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          if (!this.$refs.editUE._data.content) {
            return this.$message.error("内容不能为空");
          }
          this.editForm.content = this.$refs.editUE._data.content;
          this.api
            .updateNews(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageListNews();
                this.editFormVisible = false;
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    addFormSubmit() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          if (!this.$refs.addUE._data.content) {
            return this.$message.error("内容不能为空");
          }
          this.addForm.subjectId = this.subject.id;
          this.addForm.content = this.$refs.addUE._data.content;
          this.api
            .addNews(this.addForm)
            .then(result => {
              if (result.success) {
                this.addForm = {
                  state: 1,
                  sort: null,
                  title: "",
                  source: "",
                  content: "",
                  img: ""
                };
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageListNews();
                this.addFormVisible = false;
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageListNews();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageListNews();
    },
    pageListNews() {
      let obj = {
        subjectId: this.subject.id,
        pageNumber: this.page.pageNumber,
        pageSize: this.page.pageSize
      };
      this.api
        .pageListNews(obj)
        .then(result => {
          if (result.success) {
            this.tableList = result.data.records;
            result.data.records.forEach(element => {
              element.createTime = this.formatDate(
                "yyyy-MM-dd",
                element.createTime
              );
            });

            this.page.total = result.data.total;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    UploadSuccess(res, file, fileList, val) {
      if (this.addFormVisible) {
        this.addForm.img = res.data;
      } else if (this.editFormVisible) {
        this.editForm.img = res.data;
      }
    },
    handleRemove(file, fileList) {
      this.addForm.img = "";
    },
    handleChange(file, fileList) {},
    beforeUpload(file) {
      const img2 = file.type.indexOf("png") > -1;
      const img = file.type.indexOf("image") > -1;
      if (!img2 && !img) {
        this.$message.error("上传文件必须图片!");
      }
      return img2 || img;
    },
    changeIowIndex(index) {
      this.$nextTick(() => {
        let oldVal = this.nowIndex;
        this.nowIndex = index;
        // let name = "myUe" + oldVal;

        // this.applyGuidForm.applyGuideItemList[oldVal].content = this.$refs[
        //   name
        // ][0].content;
      });
    },
    deleteNews() {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api
            .deleteNews({
              idList: this.idList
            })
            .then(result => {
              if (result.success) {
                this.$message.success(result.message);
                this.pageListNews();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    setGuideContent(val) {
      this.applyGuidForm.applyGuideItemList[this.nowIndex].content = val;
      console.log(this.applyGuidForm.applyGuideItemList);
    },
    selectionChange(val) {
      this.idList = [];
      val.map(e => this.idList.push(e.id));
    },
    changeSubject(data) {
      this.subject = data;
      this.pageListNews(this.subject.id);
      this.api.applyGuide
        .getApplyGuide({ subjectId: this.subject.id })
        .then(result => {
          if (result.success) {
            if (result.data) {
              this.applyGuidForm = result.data;
            } else {
              this.applyGuidForm = {
                id: "",
                subjectId: "",
                banner: "",
                applyTime: "",
                ticketTime: "",
                examTime: "",
                queryScore: "",
                state: "",
                applyGuideItemList: [
                  // { title: "", content: "" }
                ]
              };
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    changeState() {
      var state = this.applyGuidForm.state;
      var confirmTxt = "";
      if (state == 1) {
        confirmTxt = "您确定要启用此报告指南吗？";
      }
      if (state == -1) {
        confirmTxt = "您确定要禁用此报告指南吗？";
      }
      this.$confirm(confirmTxt, "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.applyGuide
            .updateApplyGuideStatus({
              subjectId: this.subject.id,
              state: state
            })
            .then(result => {
              if (result.code == 200) {
                this.$message.success(result.message);
              } else {
                if (state == 1) {
                  this.applyGuidForm.state = -1;
                }
                if (state == -1) {
                  this.applyGuidForm.state = 1;
                }
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              if (state == 1) {
                this.applyGuidForm.state = -1;
              }
              if (state == -1) {
                this.applyGuidForm.state = 1;
              }
              console.log(error);
            });
        })
        .catch(() => {
          if (state == 1) {
            this.applyGuidForm.state = -1;
          }
          if (state == -1) {
            this.applyGuidForm.state = 1;
          }
        });
    },
    deleteTabs(index) {
      this.$confirm("您确定要进行删除此页吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.applyGuidForm.applyGuideItemList.splice(index, 1);
        })
        .catch(() => {});
    },
    addTabs() {
      this.$nextTick(() => {
        let len = this.applyGuidForm.applyGuideItemList.length + 1;
        this.applyGuidForm.applyGuideItemList.push({
          title: "标题" + len,
          content: ""
        });
        this.nowIndex = len - 1;
      });
    },
    save() {
      this.$refs.applyGuidForm.validate(valid => {
        if (valid) {
          this.applyGuidForm.subjectId = this.subject.id;
          this.api.applyGuide
            .addOrUpdateApplyGuide(this.applyGuidForm)
            .then(result => {
              if (result.success) {
                this.$message.success(result.message);
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        }
      });
    }
  },
  watch: {
    addFormVisible(val, oldVal) {
      if (!val) {
        this.$refs.addUE._data.content = "";
        this.addForm = {
          state: 1,
          sort: null,
          title: "",
          source: "",
          content: "",
          img: ""
        };
      }
    }
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
.message {
  display: flex;
  flex-direction: row;
  .state {
    span {
      padding: 4px 8px;
      color: #fff;
      border-radius: 4px;
      margin-right: 10px;
    }
  }
  .questionTypeName {
    span {
      padding: 4px 8px;
      color: #fff;
      border-radius: 4px;
      margin-right: 10px;
    }
  }
  .htmltittle {
    white-space: nowrap;
    height: 23px;
    overflow: hidden;
    text-overflow: ellipsis;
    img {
      display: none !important;
    }
    p {
      font-size: 12px !important;
      margin: 0px !important;
      white-space: nowrap !important;
      color: #606266 !important;
      img {
        display: none !important;
      }
    }
  }
}
.name-content {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  margin-left: 10px;
  .spans {
    height: 32px;
    line-height: 32px;
  }
}
.imgsss {
  max-width: 200px;
  max-height: 200px;
}
.content-text {
  width: 100px;
  height: 30px;
  line-height: 30px;
  border-radius: 4px;
  border: 1px solid rgb(77, 148, 255);
  color: rgb(77, 148, 255);
  font-size: 12px;
  text-align: center;
  background: #fff;
  &:hover {
    background: rgb(77, 148, 255);
    color: #fff;
  }
}
.row-line {
  display: flex;
  flex-direction: row;
  .line1 {
    display: flex;
    width: 80px;
    justify-content: flex-end;
    padding: 0 12px 0 0;
    align-items: flex-start;
    line-height: 32px;
    font-size: 12px !important;
    color: rgb(69, 90, 100) !important;
    font-weight: normal !important;
    text-align: right;
  }
}
.none {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  height: 100%;
  width: 100%;
  background: #fff;
}
.tabs-list {
  display: flex;
  flex-direction: row;
  font-size: 14px;
  padding-bottom: 20px;
  .list-item {
    padding-right: 20px;
    cursor: pointer !important;
    color: #409eff;
    i {
      margin-left: 6px;
    }
  }
  .list-items {
    i {
      margin-left: 6px;
    }
    padding-right: 20px;
    cursor: pointer !important;
    color: #999;
  }
}
.scoreRule {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
}
.el-form-item {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/applyGuide/index.vue